var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"id":"inlineFrameExample","src":'https://rhino.sens-eye.fr/examples/lemtosh/?id_cart='+_vm.$route.params.id+'&token='+_vm.token}})])}
var staticRenderFns = []

export { render, staticRenderFns }